import React, {Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import PracticaDecena from '../PracticaDecena';

import { setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';

const data = [
    {id:'1', numero:70},
    {id:'2', numero:71},
    {id:'3', numero:72},
    {id:'4', numero:73},
    {id:'5', numero:74},
    {id:'6', numero:75},
    {id:'7', numero:76},
    {id:'8', numero:77},
    {id:'9', numero:78},
    {id:'10', numero:79}
]

const instrucciones = 'A continuación se presentan números diferenciados por su valor posicional. El niño deberá leer en voz alta dichos números. Si necesita ayuda se puede hacer click sobre el recuadro donde presenta dificultad. Asimismo se puede hacer click sobre el ícono de ayuda.';
const miniInstrucciones = 'Lee los números.';

const M27Bis = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setearEjercicioAction('M27Bis') );
        dispatch(setearUrlAnteriorAction('matematica/conteo/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} instrucciones={instrucciones} miniInstrucciones={miniInstrucciones} />
            <PracticaDecena data={data} ejercicio="M27Bis" miniInstrucciones={"EXPRESEAR EL NÚMERO DE MANERA ORAL"} />
        </Fragment>
    );
}
 
export default M27Bis;